<template>
  <div class="dates">
    <Header v-bind:header="header"></Header>
    <v-container class="notecontainer">
    </v-container>
    <Event v-bind:years="years"></Event>
  </div>
</template>


<script>
import Header from "./Header.vue";
import Event from "./Event.vue";

export default {
  name: "Dates",
  components: {
    Header,
    Event,
  },
  data() {
    return {
      header: "Termine",
      noteCircle1: {
        id: "dates_c1",
        width: 350,
        top: -200,
        left: -100,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 7,
        transform: "rotateZ(calc(var(--parallax-value) * 0.7deg))",
        maxLimit: 4000,
        minLimit: 0,
      },
      noteCircle2: {
        id: "dates_c2",
        width: 200,
        top: -0,
        left: -100,
        style: "stroke-dasharray: 0.9;",
        strokeWidth: 9,
        transform: "rotateZ(calc(var(--parallax-value) * 0.9deg))",
        maxLimit: 4000,
        minLimit: 0,
      },
      years: [
        {
          year: 2022,
          events: [
             {
              id: 1,
              month: "April",
              day: "29",
              city: "Bargteheide",
              location: "Kleines Theater (feat. Ingolf Burkhardt, tp und flh)",
            },
            {
              id: 2,
              month: "Oktober",
              day: "8",
              city: "Hamburg",
              location: "Birdland",
            }
          ]
        },
        {
          year: 2023,
          events: [
            {
              id: 3,
              month: "Februar",
              day: "26",
              city: "Lüneburg",
              location: "Theater Lüneburg/Jazz IG",
            }
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.notecontainer {
  position: relative;
}
</style>